import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  listSellerProducts,
  createSellerProduct,
  deleteSellerProduct,
  getMasterProductSpecs,
  updateSellerProduct,
  getSellerProductById
} from "../../api/sellerProducts.api";
// import { getLoggedInUser } from "../../api";
import { useAuth } from "../../context/AuthContext";
import { listProductByParams } from "../../api/product.api";
import { listMasterProductsByParams } from "../../api/masterProduct.api";
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Input, Label, Row, Col, Tooltip
} from "reactstrap";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";

import StatusBadge from "../../components/StatusBadge";

const initialState = {
  product_id: null,
  master_product_id: null,
  brand_name: "",
  main_image: "",
  additional_images: [],
  min_orders: "",
  response_time: "",
  warranty_years: "",
  seller_notes: "",
  certifications: "",
  product_origin: "",
  is_active: 1 //  NEW
};

const SellerProducts = () => {

  const [data, setData] = useState([]);
  const [values, setValues] = useState(initialState);
  const [modal_add, setModalAdd] = useState(false);
  const [modal_edit, setModalEdit] = useState(false);
  const [modal_delete, setModalDelete] = useState(false);

  const [_id, set_Id] = useState("");
  const [remove_id, setRemove_id] = useState("");

  const [products, setProducts] = useState([]);
  const [masterProducts, setMasterProducts] = useState([]);
  const [selectedMaster, setSelectedMaster] = useState(null);
  const [masterSpecs, setMasterSpecs] = useState([]);

  // const [user, setUser] = useState(null);
  const { user } = useAuth();
  const [query, setQuery] = useState("");
  const [filter, setFilter] = useState(true);
  const [pageNo, setPageNo] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const [mainImageFile, setMainImageFile] = useState(null);
  const [additionalFiles, setAdditionalFiles] = useState([]);

  const [tooltips, setTooltips] = useState({
    addProduct: false,
    editBtn: false,
    deleteBtn: false,
    updateListing: false,
    cancelDelete: false,
    deletePermanently: false
  });

  const toggleTooltip = (tooltipName) => {
    setTooltips(prev => ({
      ...prev,
      [tooltipName]: !prev[tooltipName]
    }));
  };


  const fetchDropdowns = async () => {
    const pRes = await listProductByParams({ per_page: 100 });
    setProducts(pRes.data.data[0]?.data || []);
  };

  const fetchTable = async () => {
    setLoading(true);
    const skip = (pageNo - 1) * perPage;
    const res = await listSellerProducts({
      skip,
      per_page: perPage,
      match: query,
      is_active: filter
    });

    if (res.data.data.length > 0) {
      const result = res.data.data[0];
      setData(result.data);
      setTotalRows(result.count);
    } else {
      setData([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDropdowns();
  }, []);

  useEffect(() => {
    fetchTable();
  }, [query, filter, pageNo, perPage]);

  // --- HANDLERS ---
  const handleProductChange = async (e) => {
    const pid = e.target.value;
    setValues({ ...values, product_id: pid, master_product_id: null });
    setSelectedMaster(null);
    setMasterSpecs([]);

    if (pid) {
      const mRes = await listMasterProductsByParams({ product_id: pid, per_page: 100 });
      const options = (mRes.data.data[0]?.data || []).map(m => ({
        value: m.id,
        label: `${m.brand_name} - ${m.model_number}`,
        original: m
      }));
      setMasterProducts(options);
    } else {
      setMasterProducts([]);
    }
  };

  const handleMasterChange = async (selected) => {
    setSelectedMaster(selected);
    const mid = selected ? selected.value : null;
    setValues({ ...values, master_product_id: mid });

    if (mid) {
      const sRes = await getMasterProductSpecs(mid);
      setMasterSpecs(sRes.data.data || []);
    } else {
      setMasterSpecs([]);
    }
  };

  const handleChange = (e) =>
    setValues({ ...values, [e.target.name]: e.target.value });

  const handleCreate = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.keys(values).forEach(key => {
      if (values[key] !== null && values[key] !== "" && key !== "additional_images") {
        formData.append(key, values[key]);
      }
    });

    if (mainImageFile) formData.append("main_image", mainImageFile);
    if (additionalFiles) {
      Array.from(additionalFiles).forEach(file => {
        formData.append("additional_images", file);
      });
    }

    try {
      await createSellerProduct(formData);
      toast.success("Added successfully");
      setModalAdd(false);
      fetchTable();
    } catch {
      toast.error("Error adding product");
    }
  };

  const handleEdit = async (id) => {
    set_Id(id);
    const res = await getSellerProductById(id);
    const prod = res.data.data;
    setValues(prod);

    // populate dropdowns
    if (prod.product_id) {
      const mRes = await listMasterProductsByParams({ product_id: prod.product_id, per_page: 100 });
      const options = (mRes.data.data[0]?.data || []).map(m => ({
        value: m.id,
        label: `${m.brand_name} - ${m.model_number}`
      }));
      setMasterProducts(options);

      const matched = options.find(o => o.value === prod.master_product_id);
      setSelectedMaster(matched || null);

      if (prod.master_product_id) {
        const sRes = await getMasterProductSpecs(prod.master_product_id);
        setMasterSpecs(sRes.data.data || []);
      }
    }

    setModalEdit(true);
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    Object.keys(values).forEach(key => {
      if (values[key] !== null && values[key] !== "" && key !== "additional_images") {
        // Handle arrays by converting to JSON string
        if (Array.isArray(values[key])) {
          formData.append(key, JSON.stringify(values[key]));
        } else {
          formData.append(key, values[key]);
        }
      }
    });

    // Explicitly append additional_images if they exist and no new files are being uploaded
    if (!additionalFiles || additionalFiles.length === 0) {
      if (values.additional_images && Array.isArray(values.additional_images) && values.additional_images.length > 0) {
        formData.append("additional_images", JSON.stringify(values.additional_images));
      }
    }

    if (mainImageFile) formData.append("main_image", mainImageFile);
    if (additionalFiles && additionalFiles.length > 0) {
      Array.from(additionalFiles).forEach(file => {
        formData.append("additional_images", file);
      });
    }

    try {
      await updateSellerProduct(_id, formData);
      toast.success("Updated successfully");
      setModalEdit(false);
      fetchTable();
    } catch {
      toast.error("Error updating");
    }
  };

  const handleDelete = async () => {
    await deleteSellerProduct(remove_id);
    toast.success("Deleted");
    setModalDelete(false);
    fetchTable();
  };

  const customStyles = {
    headRow: { style: { borderBottom: "2px solid #f3f4f6" } },
    headCells: {
      style: {
        color: "#6b7280",
        fontWeight: "700",
        textTransform: "uppercase",
        fontSize: "11px",
        letterSpacing: "0.5px"
      }
    },
    cells: { style: { fontSize: "14px", color: "#374151", padding: "15px 10px" } },
  };

  const columns = [
    { name: "Image", width: "80px", cell: r => (
      r.main_image 
        ? <img src={`https://aaeternitas.com/uploads/products/${r.main_image}`} alt="img" width="40" height="40" className="rounded" style={{ objectFit: "cover" }} /> 
        : <div className="bg-light rounded d-flex align-items-center justify-content-center" style={{ width: "40px", height: "40px", fontSize: "10px" }}>N/A</div>
    )},
    { name: "Product", selector: r => r.product_name, grow: 1.5, style: { fontWeight: "600" } },
    { name: "Brand & Model", cell: r => (
      <div>
        <div className="fw-bold">{r.brand_name}</div>
        <div className="small text-muted">{r.model_number}</div>
      </div>
    )},
    { name: "Status", center: true, cell: (r) => <StatusBadge status={r.is_active ? "ACTIVE" : "INACTIVE"} /> },
    { name: "Verified", center: true, cell: (r) => <StatusBadge status={r.is_verified} /> },
    {
      name: "Actions", right: true, cell: (row) => (
        <div className="d-flex gap-3">
          <button id={`editBtn-${row.id}`} className="btn btn-link p-0 text-muted" onClick={() => handleEdit(row.id)}>🖊️</button>
          <Tooltip placement="top" isOpen={tooltips[`editBtn-${row.id}`]} target={`editBtn-${row.id}`} toggle={() => setTooltips(prev => ({...prev, [`editBtn-${row.id}`]: !prev[`editBtn-${row.id}`]}))}>
            Edit product details
          </Tooltip>
          <button id={`deleteBtn-${row.id}`} className="btn btn-link p-0 text-danger" onClick={() => { setRemove_id(row.id); setModalDelete(true) }}>🗑️</button>
          <Tooltip placement="top" isOpen={tooltips[`deleteBtn-${row.id}`]} target={`deleteBtn-${row.id}`} toggle={() => setTooltips(prev => ({...prev, [`deleteBtn-${row.id}`]: !prev[`deleteBtn-${row.id}`]}))}>
            Delete this product
          </Tooltip>
        </div>
      )
    }
  ];

  const uploadBoxStyle = {
    border: "2px dashed #cbd5e1", 
    borderRadius: "12px", 
    padding: "20px",
    textAlign: "center", 
    cursor: "pointer", 
    backgroundColor: "#f8fafc", 
    marginBottom: "20px",
    transition: "0.2s ease"
  };

  return (
    <div style={{ backgroundColor: "#ffffff", padding: "clamp(15px, 3vw, 24px)", borderRadius: "12px", border: "1px solid #e5e7eb" }}>

      {/* COMBINED HEADER ROW */}
      <div className="d-flex justify-content-between align-items-md-center align-items-start mb-4 flex-wrap gap-3">
        
        {/* LEFT: TITLE */}
        <div>
          <h4 className="fw-bold m-0" style={{color:"#112347"}}>Product Catalog</h4>
          <p className="text-muted small m-0">Manage your product listings and specifications</p>
        </div>

        {/* RIGHT: FILTERS & BUTTON */}
        <div className="d-flex align-items-center flex-wrap gap-3">
          
          {/* Active Checkbox */}
          <div className="form-check mb-0 d-flex align-items-center">
            <Input
              type="checkbox"
              className="form-check-input m-0"
              checked={filter}
              onChange={(e) => setFilter(e.target.checked)}
              id="activeOnlyCheck"
              style={{ cursor: "pointer" }}
            />
            <Label className="form-check-label ms-2 mb-0 small fw-bold text-muted" htmlFor="activeOnlyCheck" style={{ cursor: "pointer" }}>
              Active Only
            </Label>
          </div>

          {/* Search Bar */}
          <div className="position-relative" style={{ width: "clamp(200px, 25vw, 300px)" }}>
            <span className="position-absolute translate-middle-y top-50 ms-3 text-muted">🔍</span>
            <Input
              placeholder="Search Listings..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              style={{ backgroundColor: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", paddingLeft: "40px" }}
            />
          </div>

          {/* Add Product Button */}
          <button
            id="addProductBtn"
            className="btn fw-bold px-4 py-2 text-white"
            style={{ backgroundColor: "#112347", borderRadius: "8px", whiteSpace: "nowrap" }}
            onClick={() => {
              setValues(initialState);
              setSelectedMaster(null);
              setModalAdd(true);
            }}
          >
            + Add Product
          </button>
          <Tooltip placement="top" isOpen={tooltips.addProduct} target="addProductBtn" toggle={() => toggleTooltip('addProduct')}>
            Add a new product to your catalog
          </Tooltip>
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive border rounded-3 overflow-hidden">
        <DataTable
          columns={columns}
          data={data}
          progressPending={loading}
          pagination
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={setPageNo}
          onChangeRowsPerPage={setPerPage}
          customStyles={customStyles}
        />
      </div>

      {/* MODALS */}
      {/* 1. ADD MODAL */}
      <Modal isOpen={modal_add} toggle={() => setModalAdd(false)} size="lg" centered backdrop="static">
        <ModalHeader toggle={() => setModalAdd(false)} className="border-0 pb-0">
          <h4 className="fw-bold m-0" style={{ color: "#112347" }}>List New Product</h4>
          <p className="text-muted small m-0 mt-1">Map to a master product and add your selling details.</p>
        </ModalHeader>
        
        <ModalBody className="pt-4 px-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          
          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Product Mapping</h6>
          <Row className="g-3 mb-4">
            <Col md="6">
              <Label className="small fw-bold">Select Category</Label>
              <Input type="select" value={values.product_id || ""} onChange={handleProductChange} style={{ borderRadius: "8px", backgroundColor: "#f8fafc" }}>
                <option value="">Select Category</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.product_name}</option>)}
              </Input>
            </Col>

            <Col md="6">
              <Label className="small fw-bold">Select Master Product</Label>
              <Select
                options={masterProducts}
                value={selectedMaster}
                onChange={handleMasterChange}
                placeholder="Search Brand/Model..."
                isDisabled={!values.product_id}
                styles={{ control: (base) => ({ ...base, borderRadius: "8px", backgroundColor: "#f8fafc", borderColor: "#dee2e6" }) }}
              />
            </Col>
          </Row>

          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Media Uploads</h6>
          <Row className="g-3 mb-4">
            <Col md="6">
              <Label className="small fw-bold">Primary Image (Required)</Label>
              <div style={uploadBoxStyle}>
                <Input type="file" accept="image/*" onChange={(e) => setMainImageFile(e.target.files[0])} />
                <div className="small text-muted mt-2">Upload the main display image</div>
              </div>
            </Col>

            <Col md="6">
              <Label className="small fw-bold">Additional Images</Label>
              <div style={uploadBoxStyle}>
                <Input type="file" accept="image/*" multiple onChange={(e) => setAdditionalFiles(e.target.files)} />
                <div className="small text-muted mt-2">Upload up to 4 extra angles</div>
              </div>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Selling & Operations</h6>
          <Row className="g-3 mb-4">
            <Col md="4">
              <Label className="small fw-bold">Min Order Qty</Label>
              <Input name="min_orders" type="number" placeholder="e.g. 5" value={values.min_orders} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>

            <Col md="4">
              <Label className="small fw-bold">Response Time</Label>
              <Input name="response_time" placeholder="e.g. 24 hours" value={values.response_time} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>

            <Col md="4">
              <Label className="small fw-bold">Warranty (Years)</Label>
              <Input name="warranty_years" type="number" placeholder="e.g. 2" value={values.warranty_years} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>

            <Col md="6">
              <Label className="small fw-bold">Certifications</Label>
              <Input name="certifications" placeholder="e.g. ISO 9001, CE" value={values.certifications} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>

            <Col md="6">
              <Label className="small fw-bold">Product Origin</Label>
              <Input name="product_origin" placeholder="e.g. India" value={values.product_origin} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>

            <Col md="12">
              <Label className="small fw-bold">Seller Notes / Description</Label>
              <Input type="textarea" name="seller_notes" placeholder="Highlight key benefits..." value={values.seller_notes} onChange={handleChange} style={{ borderRadius: "8px", minHeight: "80px" }} />
            </Col>
          </Row>

          {masterSpecs.length > 0 && (
            <div className="p-3 mb-3 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
              <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Locked Master Specifications</h6>
              <Row className="g-3">
                {masterSpecs.map((s, i) => (
                  <Col md="4" key={i}>
                    <Label className="small fw-bold">{s.spec_label}</Label>
                    <Input 
                      style={{ backgroundColor: "#e9ecef", borderRadius: "8px" }} 
                      value={s.exact_value || s.spec_value || ""} 
                      disabled 
                    />
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {/* ACTIVE CHECKBOX */}
          <div className="mt-4 p-3 d-flex align-items-center" style={{ backgroundColor: "#ecfdf5", borderRadius: "8px", border: "1px solid #a7f3d0" }}>
            <Label className="m-0 d-flex align-items-center gap-2 fw-bold" style={{ color: "#065f46", cursor: "pointer" }}>
              <input
                type="checkbox"
                style={{ width: "18px", height: "18px", accentColor: "#059669", cursor: "pointer" }}
                checked={values.is_active === 1}
                onChange={(e) => setValues({...values, is_active: e.target.checked ? 1 : 0})}
              /> 
              Set as Active Listing immediately
            </Label>
          </div>

        </ModalBody>

        <ModalFooter style={{ borderTop: "1px solid #e5e7eb", padding: "20px 24px" }}>
          <button 
            className="btn w-100 fw-bold" 
            onClick={handleCreate}
            style={{ 
              backgroundColor: "#112347", 
              color: "#ffffff", 
              padding: "12px", 
              borderRadius: "8px" 
            }}
          >
            Submit Listing
          </button>
        </ModalFooter>
      </Modal>

      {/* 2. EDIT MODAL */}
      <Modal isOpen={modal_edit} toggle={() => setModalEdit(false)} size="lg" centered backdrop="static">
        <ModalHeader toggle={() => setModalEdit(false)} className="border-0 pb-0">
          <h4 className="fw-bold m-0" style={{ color: "#112347" }}>Edit Listing</h4>
        </ModalHeader>
        
        <ModalBody className="pt-4 px-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          
          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Product Mapping</h6>
          <Row className="g-3 mb-4">
            <Col md="6">
              <Label className="small fw-bold">Category</Label>
              <Input type="select" value={values.product_id || ""} onChange={handleProductChange} style={{ borderRadius: "8px" }}>
                <option value="">Select</option>
                {products.map(p => <option key={p.id} value={p.id}>{p.product_name}</option>)}
              </Input>
            </Col>
            <Col md="6">
              <Label className="small fw-bold">Master Product</Label>
              <Select
                options={masterProducts}
                value={selectedMaster}
                onChange={handleMasterChange}
                isDisabled={!values.product_id}
                styles={{ control: (base) => ({ ...base, borderRadius: "8px" }) }}
              />
            </Col>
          </Row>

          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Media Updates</h6>
          
          {/* Current Images Display */}
          <Row className="g-3 mb-4">
            <Col md="6">
              <Label className="small fw-bold">Current Primary Image</Label>
              {values.main_image ? (
                <div style={{ 
                  border: "1px solid #e5e7eb", 
                  borderRadius: "8px", 
                  padding: "10px", 
                  textAlign: "center",
                  backgroundColor: "#f9fafb"
                }}>
                  <img 
                    src={`https://aaeternitas.com/uploads/products/${values.main_image}`} 
                    alt="current-main" 
                    style={{ maxWidth: "100%", maxHeight: "150px", borderRadius: "6px", objectFit: "contain" }} 
                  />
                  <div className="small text-muted mt-2">{values.main_image}</div>
                </div>
              ) : (
                <div style={{ 
                  border: "2px dashed #cbd5e1", 
                  borderRadius: "8px", 
                  padding: "20px",
                  textAlign: "center",
                  backgroundColor: "#f8fafc"
                }}>
                  <div className="text-muted small">No primary image</div>
                </div>
              )}
            </Col>
            <Col md="6">
              <Label className="small fw-bold">Current Additional Images</Label>
              {values.additional_images && values.additional_images.length > 0 ? (
                <div style={{ 
                  border: "1px solid #e5e7eb", 
                  borderRadius: "8px", 
                  padding: "10px",
                  backgroundColor: "#f9fafb"
                }}>
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(80px, 1fr))", gap: "10px" }}>
                    {values.additional_images.map((img, idx) => (
                      <div key={idx} style={{ textAlign: "center" }}>
                        <img 
                          src={`https://aaeternitas.com/uploads/products/${img}`} 
                          alt={`additional-${idx}`}
                          style={{ width: "100%", height: "80px", borderRadius: "6px", objectFit: "cover" }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div style={{ 
                  border: "2px dashed #cbd5e1", 
                  borderRadius: "8px", 
                  padding: "20px",
                  textAlign: "center",
                  backgroundColor: "#f8fafc"
                }}>
                  <div className="text-muted small">No additional images</div>
                </div>
              )}
            </Col>
          </Row>

          {/* Replace Images Section */}
          <Row className="g-3 mb-4">
            <Col md="6">
              <Label className="small fw-bold">Replace Primary Image</Label>
              <div style={uploadBoxStyle}>
                <Input type="file" accept="image/*" onChange={(e) => setMainImageFile(e.target.files[0])} />
                {mainImageFile && <div className="small text-success mt-2">✓ New image selected: {mainImageFile.name}</div>}
              </div>
            </Col>
            <Col md="6">
              <Label className="small fw-bold">Replace Additional Images</Label>
              <div style={uploadBoxStyle}>
                <Input type="file" accept="image/*" multiple onChange={(e) => setAdditionalFiles(e.target.files)} />
                {additionalFiles && additionalFiles.length > 0 && <div className="small text-success mt-2">✓ {additionalFiles.length} new image(s) selected</div>}
              </div>
            </Col>
          </Row>

          <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Selling & Operations</h6>
          <Row className="g-3 mb-4">
            <Col md="4">
              <Label className="small fw-bold">Min Order Qty</Label>
              <Input name="min_orders" type="number" value={values.min_orders || ""} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>
            <Col md="4">
              <Label className="small fw-bold">Response Time</Label>
              <Input name="response_time" value={values.response_time || ""} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>
            <Col md="4">
              <Label className="small fw-bold">Warranty (Years)</Label>
              <Input name="warranty_years" type="number" value={values.warranty_years || ""} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>
            <Col md="6">
              <Label className="small fw-bold">Certifications</Label>
              <Input name="certifications" value={values.certifications || ""} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>
            <Col md="6">
              <Label className="small fw-bold">Product Origin</Label>
              <Input name="product_origin" value={values.product_origin || ""} onChange={handleChange} style={{ borderRadius: "8px" }} />
            </Col>
            <Col md="12">
              <Label className="small fw-bold">Seller Notes</Label>
              <Input type="textarea" name="seller_notes" value={values.seller_notes || ""} onChange={handleChange} style={{ borderRadius: "8px", minHeight: "80px" }} />
            </Col>
          </Row>

          {masterSpecs.length > 0 && (
            <div className="p-3 mb-3 border rounded" style={{ backgroundColor: "#f8f9fa" }}>
              <h6 className="fw-bold mb-3 text-uppercase text-muted" style={{ fontSize: "12px", letterSpacing: "1px" }}>Locked Master Specifications</h6>
              <Row className="g-3">
                {masterSpecs.map((s, i) => (
                  <Col md="4" key={i}>
                    <Label className="small fw-bold">{s.spec_label}</Label>
                    <Input style={{ backgroundColor: "#e9ecef", borderRadius: "8px" }} value={s.exact_value || s.spec_value || ""} disabled />
                  </Col>
                ))}
              </Row>
            </div>
          )}

          {/*  ACTIVE CHECKBOX UPDATE */}
          <div className="mt-4 p-3 d-flex align-items-center" style={{ backgroundColor: "#ecfdf5", borderRadius: "8px", border: "1px solid #a7f3d0" }}>
            <Label className="m-0 d-flex align-items-center gap-2 fw-bold" style={{ color: "#065f46", cursor: "pointer" }}>
              <input
                type="checkbox"
                style={{ width: "18px", height: "18px", accentColor: "#059669", cursor: "pointer" }}
                checked={values.is_active === 1 || values.is_active === true}
                onChange={(e) => setValues({...values, is_active: e.target.checked ? 1 : 0})}
              /> 
              Listing is Active
            </Label>
          </div>

        </ModalBody>
        <ModalFooter style={{ borderTop: "1px solid #e5e7eb", padding: "20px 24px" }}>
          <button id="updateListingBtn" className="btn w-100 fw-bold" onClick={handleUpdate} style={{ backgroundColor: "#112347", color: "#ffffff", padding: "12px", borderRadius: "8px" }}>
            Update Listing
          </button>
          <Tooltip placement="top" isOpen={tooltips.updateListing} target="updateListingBtn" toggle={() => toggleTooltip('updateListing')}>
            Save changes to this product
          </Tooltip>
        </ModalFooter>
      </Modal>

      {/* 3. DELETE MODAL */}
      <Modal isOpen={modal_delete} toggle={() => setModalDelete(false)} centered>
        <ModalBody className="text-center py-4">
          <h5 className="fw-bold mb-3">Delete Listing?</h5>
          <p className="text-muted">This action cannot be undone.</p>
          <div className="d-flex gap-2 justify-content-center mt-4">
            <button id="cancelDeleteBtn" className="btn btn-light px-4 fw-bold" onClick={() => setModalDelete(false)}>Cancel</button>
            <Tooltip placement="top" isOpen={tooltips.cancelDelete} target="cancelDeleteBtn" toggle={() => toggleTooltip('cancelDelete')}>
              Close without deleting
            </Tooltip>
            <button id="deletePermBtn" className="btn btn-danger px-4 fw-bold" onClick={handleDelete}>Delete Permanently</button>
            <Tooltip placement="top" isOpen={tooltips.deletePermanently} target="deletePermBtn" toggle={() => toggleTooltip('deletePermanently')}>
              Permanently remove this product
            </Tooltip>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SellerProducts;